export const GroupTermQueryKeys = {
  all: ['package'] as const,
  lists: () => [...GroupTermQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...GroupTermQueryKeys.lists(), filters] as const,
  details: () => [...GroupTermQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...GroupTermQueryKeys.details(), id] as const,
};
